import { render, staticRenderFns } from "./LoginAndForgot.vue?vue&type=template&id=cc3ac630&scoped=true"
import script from "./LoginAndForgot.vue?vue&type=script&lang=js"
export * from "./LoginAndForgot.vue?vue&type=script&lang=js"
import style0 from "./LoginAndForgot.vue?vue&type=style&index=0&id=cc3ac630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3ac630",
  null
  
)

export default component.exports